:host{display:flex;align-items:center}mat-icon.lightbulb{color:#13b152}
/*# sourceMappingURL=training-answer-icon.component.css.map */
